/* eslint-disable max-len */
import * as React from 'react';
import Svg, { SvgProps, G, Path, Mask } from 'react-native-svg';

export function EnglishFlagSvg(props: SvgProps) {
  return (
    <Svg
      width={24}
      height={18}
      viewBox="0 0 24 18"
      fill="none"
      {...props}
    >
      <Mask id="mask0_634_26175" x={0} y={0} width={24} height={18}>
        <Path d="M0 0H24V18H0V0Z" fill="white" />
      </Mask>
      <G mask="url(#mask0_634_26175)">
        <Path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M0 0V18H24V0H0Z"
          fill="#2E42A5"
        />
        <Mask id="mask1_634_26175" x={0} y={0} width={24} height={18}>
          <Path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M0 0V18H24V0H0Z"
            fill="white"
          />
        </Mask>
        <G mask="url(#mask1_634_26175)">
          <Mask
            id="mask2_634_26175"
            x={0}
            y={0}
            width={24}
            height={18}
          >
            <Path d="M0 0H24V18H0V0Z" fill="white" />
          </Mask>
          <G mask="url(#mask2_634_26175)">
            <Path
              d="M-2.67188 16.7157L2.60939 18.9492L24.1203 2.43L26.9061 -0.889109L21.2585 -1.63562L12.4847 5.48298L5.42272 10.2793L-2.67188 16.7157Z"
              fill="white"
            />
            <Path
              d="M-1.94922 18.2781L0.741343 19.5742L25.9054 -1.19999H22.1275L-1.94922 18.2781Z"
              fill="#F50100"
            />
            <Path
              d="M26.6719 16.7157L21.3906 18.9492L-0.120319 2.43L-2.90607 -0.889109L2.74149 -1.63562L11.5153 5.48298L18.5773 10.2793L26.6719 16.7157Z"
              fill="white"
            />
            <Path
              d="M26.4922 17.8366L23.8016 19.1328L13.0865 10.2383L9.90973 9.24453L-3.1736 -0.879864H0.604261L13.6802 9.00422L17.1535 10.1959L26.4922 17.8366Z"
              fill="#F50100"
            />
            <Path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M14.8321 -1.5H9.16543V6H-1.48047V12H9.16543V19.5H14.8321V12H25.5195V6H14.8321V-1.5Z"
              fill="#F50100"
            />
            <Path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M9.16543 6H-1.48047V12H9.16543V19.5H14.8321V12H25.5195V6H14.8321V-1.5H9.16543V6ZM10.4154 -0.25V7.25H-0.230469V10.75H10.4154V18.25H13.5821V10.75H24.2695V7.25H13.5821V-0.25H10.4154Z"
              fill="white"
            />
          </G>
        </G>
      </G>
    </Svg>
  );
}
